import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../helpers';
//////////////////////////////////////////////////

const selectDashboardsStore = ({ dashboards }) => dashboards;

const makeSelectDashboardsStore = () => createSelector(
  selectDashboardsStore,
  (store) => ({ ...store }),
);

const makeSelectDashboard = () => createSelector(
  selectDashboardsStore,
  ({ dashboard }) => dashboard,
);

const makeSelectFilters = () => createSelector(
  selectDashboardsStore,
  ({ filters }) => filters,
);

const makeSelectDashboardType = () => createSelector(
  selectDashboardsStore,
  ({ dashboardType }) => dashboardType,
);

const makeSelectCurrencySymbol = () => createSelector(
  selectDashboardsStore,
  (store) => {
    const { filters, normalizedCurrency } = store;

    const { enterprise } = filters;

    const enterpriseGuid = R.or(enterprise, G.getAmousCurrentBranchGuidFromWindow());

    return G.getCurrencySymbol2(G.getPropFromObject(enterpriseGuid, normalizedCurrency));
  },
);

const makeSelectTitleSortValues = () => createSelector(
  selectDashboardsStore,
  ({ titleSortValues }) => titleSortValues,
);

const makeSelectTableTitleFilters = () => createSelector(
  selectDashboardsStore,
  ({ tableTitleFilters }) => tableTitleFilters,
);

export {
  makeSelectFilters,
  makeSelectDashboard,
  makeSelectDashboardType,
  makeSelectCurrencySymbol,
  makeSelectDashboardsStore,
  makeSelectTitleSortValues,
  makeSelectTableTitleFilters,
};
